import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from '../services/session.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private sessionService: SessionService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        const isLoggedIn = this.sessionService.isLoggedIn();        
        if (isLoggedIn) {
            return true;
        }
        
        const isPublicRoute = this.isPublicRoute(state.url);
        
        if (isPublicRoute) {
            return true;
        }
        
        this.sessionService.redirectUrl = state.url;
        this.router.navigate(['/auth/sign-in']);
        return false;
    }
    
    private isPublicRoute(url: string): boolean {
        const publicRoutes = ['/auth/sign-in', '/auth/sign-up', '/auth/forgot-password', '/session-expired'];
        return publicRoutes.some(route => url.startsWith(route));
    }
}